import { render, staticRenderFns } from "./fbaResultList.vue?vue&type=template&id=24130509&scoped=true"
import script from "./fbaResultList.vue?vue&type=script&lang=js"
export * from "./fbaResultList.vue?vue&type=script&lang=js"
import style0 from "./fbaResultList.vue?vue&type=style&index=0&id=24130509&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24130509",
  null
  
)

export default component.exports